import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { getShopIdFromUrl } from '../utils/routeUtils';

export const useShopId = () => {
  const params = useParams();

  // Get shop ID from URL parameters or extract from pathname
  let shopId = params.shopId || getShopIdFromUrl() || 'all';

  // Memorize the return object to prevent unnecessary re-renders
  return useMemo(() => ({
    shopId,
    isAllShops: shopId === 'all',
    isSpecificShop: shopId !== 'all'
  }), [shopId]);
};

export default useShopId;